import { ThemeProvider } from '@mui/material';
import { useMemo } from 'react';

import {
  brandedTheme,
  unbrandedTheme,
  theme as voltTheme,
  compactSpacing,
} from '../../theme';

import type { ChkThemeProviderProps } from './ChkThemeProvider.types';

export function ChkThemeProvider({
  children,
  variant,
  overwrites,
  customerBranding,
  zoom,
}: ChkThemeProviderProps) {
  const theme = useMemo(() => {
    const baseTheme = variant === 'unbranded' ? unbrandedTheme : voltTheme;
    const spacingOverwrites = zoom?.isElevatedZoom
      ? { spacing: compactSpacing }
      : {};

    return brandedTheme(customerBranding, baseTheme, {
      zoom,
      ...spacingOverwrites,
      ...overwrites,
    });
  }, [variant, customerBranding, overwrites, zoom]);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
